/**
 * Default imgix options for artwork thumbnail and modal in cart/checkout.
 * Pass these into remote-image helpers from the caller (e.g. ArtworkPreview, LineItemImage).
 */
import type { ImgixModalOptions, ImgixThumbnailOptions } from "common/utils/remote-image";

export const DEFAULT_ARTWORK_THUMBNAIL_OPTIONS: ImgixThumbnailOptions = {
  width: 600,
  fit: "max",
  auto: "format,compress",
  quality: 70
};

/** Fallback max width when window is unavailable (SSR / no DOM). */
const ARTWORK_MODAL_SSR_FALLBACK_WIDTH = 2048;
/** Cap on viewport width used for modal size. */
const ARTWORK_MODAL_VIEWPORT_CAP = 600;
/** Cap on device pixel ratio for modal size. */
const ARTWORK_MODAL_DPR_CAP = 3;

export const DEFAULT_ARTWORK_MODAL_OPTIONS: ImgixModalOptions = {
  maxWidth: 3072,
  capWidth: ARTWORK_MODAL_VIEWPORT_CAP,
  zoomHeadroom: 1.25,
  dprCap: ARTWORK_MODAL_DPR_CAP,
  ssrFallbackWidth: ARTWORK_MODAL_SSR_FALLBACK_WIDTH,
  fit: "max",
  auto: "format,compress",
  quality: 75
};
